<template>
  <div class="main">
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            物产云发布历史
          </div>
        </template>
        <div class="collapse-content">
          <vxe-table
            border
            show-overflow
            resizable
            ref="settleAccountsRef"
            class="vxe-table-element"
            size="mini"
            align="center"
            :auto-resize="true"
            :data="tableData"
            :row-config="{ height: 220 }"
            :column-config="{ resizeable: true }"
            :scroll-y="{ gt: 0 }"
            height="500"
          >
            <!-- <vxe-table-column type="checkbox" width="50" fixed="left"> </vxe-table-column>
            <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column> -->
            <vxe-table-column
              v-for="(item, index) in tableColumns"
              :key="index"
              :type="item.type"
              :fixed="item.fixed"
              :field="item.field"
              :title="item.title"
              :width="item.width"
              :sortable="item.sortable"
            >
              <template v-slot="{ row }">
                <template v-if="item?.field == 'remark'">
                  <div v-for="(item1, index1) in row['remark']" :key="index1">{{ item1 }}</div>
                </template>
                <template v-else>{{ row[item.field] }}</template>
              </template>
            </vxe-table-column>
          </vxe-table>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
  export default {
    name: 'publishHistory',

    data() {
      return {
        activeNames: '1',
        tableData: [
          // { a: 'aa', b: 'bb', remark: ['jkladsjsahjsda', 'adsad'] }
        ],
      };
    },
    computed: {
      tableColumns() {
        return [
          //   { type: 'seq', title: '序号', width: 50 },
          {
            field: 'a',
            title: '版本',
            visible: true,
          },
          {
            field: 'b',
            title: '发布时间',
            visible: true,
          },
          {
            field: 'remark',
            title: '发布备注',
            visible: true,
          },
        ];
      },
    },
  };
</script>

<style></style>
